import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice.ts"
import { handleGetResponseData } from "../../../utils/handlers/handle-get-response-data"
import { updateProfile } from "../../LoginPage/redux/auth.slice"
import { type UserInfo } from "../../LoginPage/types/auth.types.ts"
import * as services from "../services"

export const fetchUserInfo = createAsyncThunk<UserInfo, void>(
  "user/fetchUserInfo",
  async (_, { dispatch, rejectWithValue }) => {
    const responseData = await services.getUserInfo()
    const response = handleGetResponseData(responseData)

    if (!response.ok) {
      const rawErrorData = responseData?.data as { details?: unknown } | null
      dispatch(errorSave(rawErrorData?.details))
      return rejectWithValue(
        response.data || { errors: "Failed to fetch user info" }
      )
    }

    if (response.data) {
      dispatch(updateProfile(response.data))
    }

    return response.data
  }
)
